<template>
  <van-swipe :autoplay="3000" @change="onChange" style="position: relative">
    <van-swipe-item v-for="(item, index) in swiperList" :key="index">
      <div class="swiper-item">
        <img v-lazy="item.image" class="swiper-image" />
        <div class="info">
          <div class="title">{{ item.name }}</div>
          <div class="sub_intro">{{ item.sub_intro }}</div>
          <div class="btn" v-if="item.website_url" @click="navigateTo(item)">
            了解详情
          </div>
        </div>
      </div>
    </van-swipe-item>

    <!-- 自定义指示器 -->
    <template #indicator>
      <div class="custombox">
        <div
          :class="['custom-indicator', { active: currentIndex === index }]"
          v-for="(item, index) in swiperList"
          :key="index"
        ></div>
      </div>
    </template>
  </van-swipe>
</template>

<script>
export default {
  name: "Swiper",
  props: {
    swiperList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  methods: {
    onChange(index) {
      this.currentIndex = index;
    },
    navigateTo(url) {
      window.open(url.website_url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-item {
  width: 100%;
  background: #141414;
  height: 400px;
  .swiper-image {
    width: 100%;
    height: 230px;
  }
  .info {
    width: 100%;
    height: 170px;
    color: #ffffff;
    text-align: center;
    padding: 20px;
    box-sizing: border-box;
    .title {
      font-weight: 500;
      font-size: 24px;
    }
    .sub_intro {
      font-weight: 400;
      font-size: 16px;
    }
    .btn {
      width: 335px;
      height: 44px;
      position: absolute;
      bottom: 19px;
      left: 20px;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      background: #d32e2e;
      text-align: center;
      line-height: 44px;
    }
  }
}
.custombox {
  display: flex;
  position: absolute;
  left: 0;
  bottom: 9px;
  justify-content: center;
  width: 100%;
  overflow: auto;
  .custom-indicator {
    width: 32px;
    height: 3px;
    background: #808080;
    margin: 0 2px;
    transition: all 0.3s ease;

    &.active {
      background-color: #d32e2e;
      transform: scaleX(1.1);
    }
  }
}
</style>
